import React, { useState, useEffect } from 'react';
import { useUserContext } from '@nexus/fff-utilities';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { trackPageLoad } from '@nexus/fff-analytics';
import Layout from '../../components/Layout';
import useLaunchDarkly from '../../hooks/useLaunchDarkly';
import MainBanner from './MainBanner';
import PerksBanner from './PerksBanner';
import ReactivateButton from './ReactivateButton';
import CouponSelector from '../Upgrade/CouponSelector';
import { Plans } from '../constants';
import { text } from './disclaimerText';
import useCouponSelector from '../../hooks/useCouponSelector';
import { searchToObject } from '../../helpers';
import styles from './reactivate-today.module.scss';

export const ReactivateToday = ({ ldClient, location: { pathname, search } }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { userInfo } = useUserContext();
  useLaunchDarkly(ldClient, userInfo);
  const {
    handleApplyCoupon,
    handleRemoveCoupon,
    couponsApplied,
    couponError,
  } = useCouponSelector();
  const { coupon_code: couponCode } = searchToObject(search);

  const isCanceled = userInfo && userInfo.user && userInfo.user.subscriptionState === 'CANCELED';

  useEffect(() => {
    if (isCanceled) {
      trackPageLoad({
        properties: { coupon_code: couponCode },
      }).then();
    }
  }, []);

  if (!isCanceled) {
    window.location.replace(process.env.REACT_APP_SITE_URL);
    return null;
  }

  return (
    <Layout isLoading={isLoading} pageTitle="Reactivate Today">
      <MainBanner couponsApplied={couponsApplied} isLoading={isLoading} setIsLoading={setIsLoading} />
      <section className={styles['coupon-selector-container']}>
        <CouponSelector
          plan={Plans.ANNUAL}
          onApplyCoupon={handleApplyCoupon}
          onRemoveCoupon={handleRemoveCoupon}
          initialCouponCode={couponCode}
          error={couponError}
          couponsApplied={couponsApplied}
        />
      </section>
      <div className={styles.divider} />
      <PerksBanner />
      <p className={styles['last-disclaimer']}>{text}</p>
      <div className={styles['button-container']}>
        <ReactivateButton couponsApplied={couponsApplied} isLoading={isLoading} setIsLoading={setIsLoading} />
      </div>
    </Layout>
  );
};

export default withLDConsumer()(ReactivateToday);
